import { render, staticRenderFns } from "./RegisterDemoPage.vue?vue&type=template&id=72acd312"
import script from "./RegisterDemoPage.vue?vue&type=script&lang=js"
export * from "./RegisterDemoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports